import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7aaa68ed")

_pushScopeId("data-v-7aaa68ed")
const _hoisted_1 = { class: "update-tips" }
const _hoisted_2 = { class: "contact-detail-slot" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_list = _resolveComponent("list")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    title: _ctx.$wordList.CommunityUpdatingList,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
    onSubmit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('submit')))
  }, {
    default: _withId(() => [
      _createVNode("p", _hoisted_1, _toDisplayString(_ctx.tips[_ctx.operateType]), 1),
      _createVNode(_component_list, {
        class: "margin-top10px height220px overflow-auto",
        showCheck: "false",
        action: false,
        headers: _ctx.headers[_ctx.operateType],
        listData: _ctx.initData
      }, {
        DetailsSlot: _withId((data) => [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", null, [
              _createVNode("img", {
                class: "img-size",
                src: require('@/assets/image/phone.png')
              }, null, 8, ["src"]),
              _createTextVNode(" " + _toDisplayString(_ctx.filterEmptyCellValue(data.scope.Phone)), 1)
            ]),
            _createVNode("div", null, [
              _createVNode("img", {
                class: "img-size",
                src: require('@/assets/image/email.png')
              }, null, 8, ["src"]),
              _createTextVNode(" " + _toDisplayString(_ctx.filterEmptyCellValue(data.scope.Email)), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["headers", "listData"])
    ]),
    _: 1
  }, 8, ["title"]))
})